import { PHYSICS } from './physics-constants.js';
import { clampStat } from './validation.js';
/**
 * Per-tick horizontal velocity change toward the input's target speed. Shared by
 * the authoritative server and the client's local-player prediction.
 */
export function horizontalMotorChange(input, currentVx, grounded, character, passive, tickScale) {
    const speed = PHYSICS.player.moveSpeed * clampStat(character.stats.speed) * (passive.speedMultiplier ?? 1);
    const balance = clampStat(character.stats.balance) * (passive.balanceMultiplier ?? 1);
    const airControl = grounded ? 1 : PHYSICS.player.airControl * (passive.airControlMultiplier ?? 1);
    // Reversing against current momentum bites harder, so direction changes feel snappy.
    const turning = input !== 0 && currentVx * input < -0.5 ? PHYSICS.player.turnAccelerationMultiplier : 1;
    const acceleration = (input === 0
        ? (grounded ? PHYSICS.player.idleGroundDeceleration : PHYSICS.player.idleAirDeceleration) * balance
        : PHYSICS.player.acceleration * clampStat(character.stats.acceleration) * (passive.accelerationMultiplier ?? 1) * airControl * turning) * tickScale;
    const desiredVx = input * speed;
    return Math.max(-acceleration, Math.min(acceleration, desiredVx - currentVx));
}
/** 0..1 charge for a shot key held for `heldMs`. */
export function shotCharge(heldMs) {
    const { chargeDeadMs, chargeFullMs } = PHYSICS.shot;
    return Math.max(0, Math.min(1, (heldMs - chargeDeadMs) / (chargeFullMs - chargeDeadMs)));
}
export function jumpVelocity(character, passive, heavy) {
    return PHYSICS.jump.speed * clampStat(character.stats.jump) * (passive.jumpMultiplier ?? 1) * (heavy ? 0.85 : 1);
}
